<template>
    <div class="notes-add">
        <slot name="trigger">
            <div class="notes-add__trigger">
                <button class="button button--blank" type="button" @click="toggleModal">
                    + {{ $t('notes.add.title') }}
                </button>
            </div>
        </slot>
        <Modal
            v-if="isOpen"
            name="notes-add"
            :title="$t('notes.add.title')"
            :direction="isRtl ? 'rtl' : 'ltr'"
            @closed="isOpen = false"
        >
            <template #content>
                <Spinner v-if="loading" />
                <div v-if="bookId" class="notes-add__content">
                    <div class="notes-add__text" :class="{ 'notes-add__text--rtl': isRtl }">
                        {{ text }}
                    </div>
                    <form id="notes-add" class="notes-add__form" @submit.prevent="save">
                        <div class="form-group">
                            <textarea
                                v-model="comment"
                                class="notes-add__comment form-group__textarea"
                                :placeholder="$t('notes.add.commentPlaceholder')"
                                required="true"
                            />
                        </div>
                        <TransitionExpand v-if="error">
                            <ErrorList :error="error" />
                        </TransitionExpand>
                    </form>
                </div>
            </template>
            <template #bottom>
                <div class="modal__confirm">
                    <button
                        type="button"
                        class="button button--negative modal__confirm-button"
                        @click.prevent="isOpen = false"
                    >
                        {{ $t('notes.add.cancel') }}
                    </button>
                    <button class="button modal__confirm-button" type="submit" form="notes-add">
                        {{ $t('notes.add.save') }}
                    </button>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand/TransitionExpand.vue';
import { saveNote } from '../../api/notes';
import { mapState } from 'vuex';
import { isRtlLanguage } from '@speechki-frontend/core/editor/utils';

export default {
    name: 'NotesAdd',
    components: {
        Modal,
        TransitionExpand,
        ErrorList,
    },
    props: {
        bookId: {
            type: [String, Number],
            default: 0,
        },
        partId: {
            required: true,
            type: Number,
        },
        text: {
            required: true,
            type: String,
        },
        timeStamps: {
            required: true,
            type: Object,
        },
        anchor: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isOpen: false,
            loading: false,
            comment: '',
            error: null,
        };
    },
    computed: {
        ...mapState({
            book: (state) => state.book.book,
        }),
        isRtl() {
            return isRtlLanguage(this.book.book_language);
        },
    },
    watch: {
        isOpen() {
            if (this.isOpen) {
                this.comment = '';
                this.error = null;
            }
        },
    },
    methods: {
        toggleModal() {
            this.isOpen = !this.isOpen;
        },
        async save() {
            try {
                this.loading = true;
                this.error = null;

                const data = {
                    book: this.bookId,
                    comment: this.comment,
                    book_part_v2: this.partId,
                    anchor: this.anchor,
                    ...this.timeStamps,
                };

                const note = await saveNote(data);

                this.$store.dispatch('pushToast', {
                    type: 'success',
                    title: this.$t('notes.add.success'),
                });

                this.$emit('added', note);
                this.isOpen = false;
            } catch (e) {
                console.log(e);
                this.error = e;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style src="./NotesAdd.scss" lang="scss"></style>
